import { render, staticRenderFns } from "./DoneTransfer.vue?vue&type=template&id=58b6a74c&scoped=true&"
import script from "./DoneTransfer.vue?vue&type=script&lang=javascript&"
export * from "./DoneTransfer.vue?vue&type=script&lang=javascript&"
import style0 from "./DoneTransfer.vue?vue&type=style&index=0&id=58b6a74c&lang=less&scoped=true&"
import style1 from "./DoneTransfer.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b6a74c",
  null
  
)

export default component.exports